import React from 'react';
import { 
    FolderOpen, 
    ArrowUpCircle, 
    RotateCcw, 
    BadgeCheck, 
    Clock3, 
    FileText, 
    Clock, 
    AlertTriangle, 
    CheckSquare 
} from 'lucide-react';

/**
 * MyProposalsStatCards — extracted from MyProposals.jsx.
 * Renders the KPI summary stat cards.
 * If isManager is true, renders 4 classic manager cards.
 * If isManager is false, renders 6 new team member assignment KPI cards with custom icons.
 */
const MyProposalsStatCards = ({
    displayTotalProposals,
    inProgressCount,
    displayDueThisWeek,
    submittedCount,
    isManager,
    metrics
}) => {
    if (isManager) {
        return (
            <section className="dashboard-summary-row" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                <div className="stat-card">
                    <div className="stat-card-header">
                        <span className="stat-card-label">Total Proposals</span>
                        <div className="stat-card-icon stat-icon-blue">
                            <FileText size={18} />
                        </div>
                    </div>
                    <div className="stat-card-content">
                        <span className="stat-card-value">{displayTotalProposals}</span>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card-header">
                        <span className="stat-card-label">In Progress</span>
                        <div className="stat-card-icon stat-icon-yellow">
                            <Clock size={18} />
                        </div>
                    </div>
                    <div className="stat-card-content">
                        <span className="stat-card-value">{inProgressCount}</span>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card-header">
                        <span className="stat-card-label">Due This Week</span>
                        <div className="stat-card-icon stat-icon-red">
                            <AlertTriangle size={18} />
                        </div>
                    </div>
                    <div className="stat-card-content">
                        <span className="stat-card-value stat-value-red">{displayDueThisWeek}</span>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card-header">
                        <span className="stat-card-label">Submitted</span>
                        <div className="stat-card-icon stat-icon-green">
                            <CheckSquare size={18} />
                        </div>
                    </div>
                    <div className="stat-card-content">
                        <span className="stat-card-value">{submittedCount}</span>
                    </div>
                </div>
            </section>
        );
    }

    // Team Member: Render 6 dynamic cards styled with user-specified custom icons
    return (
        <section className="dashboard-summary-row" style={{ gridTemplateColumns: 'repeat(6, 1fr)' }}>
            {/* Total Sections: FileText */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Total Sections</span>
                    <div className="stat-card-icon" style={{ background: '#EEF2FF', color: '#4F46E5' }}>
                        <FileText size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value">{metrics?.total_sections ?? 0}</span>
                </div>
            </div>

            {/* Total Active: FolderOpen */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Total Active</span>
                    <div className="stat-card-icon stat-icon-blue">
                        <FolderOpen size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value">{metrics?.total_active ?? displayTotalProposals}</span>
                </div>
            </div>

            {/* Refinement: RotateCcw */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Refinement</span>
                    <div className="stat-card-icon stat-icon-yellow">
                        <RotateCcw size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value">{metrics?.refinement ?? 0}</span>
                </div>
            </div>

            {/* Submitted to TL: ArrowUpCircle */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Submitted to TL</span>
                    <div className="stat-card-icon" style={{ background: '#E0F2FE', color: '#0284C7' }}>
                        <ArrowUpCircle size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value">{metrics?.submitted_to_tl ?? 0}</span>
                </div>
            </div>

            {/* Finalised: BadgeCheck */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Finalised</span>
                    <div className="stat-card-icon stat-icon-green">
                        <BadgeCheck size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value">{metrics?.finalised ?? 0}</span>
                </div>
            </div>

            {/* Due This Week: Clock3 */}
            <div className="stat-card">
                <div className="stat-card-header">
                    <span className="stat-card-label">Due This Week</span>
                    <div className="stat-card-icon stat-icon-red">
                        <Clock3 size={18} />
                    </div>
                </div>
                <div className="stat-card-content">
                    <span className="stat-card-value stat-value-red">{metrics?.due_this_week ?? displayDueThisWeek}</span>
                </div>
            </div>
        </section>
    );
};

export default MyProposalsStatCards;
